import React from 'react';
import Autocomplete from 'react-autocomplete';

const menuStyle = {
  position: 'absolute',
  left: '0',
  top: '100%',
  maxHeight: '350px',
  overflow: 'auto',
  border: '1px solid #cccccc',
};

const inputProps = {
  className: 'form-control awesomplete pillSelct-input',
  name: 'colaborador',
};

const FourthStep = props => (
  <section className='simpleSlide active'>


  {props.pedidos.map((row,id) =>

    <div className='card card-plain mb-3' key={id}>
      <div className='row'>
        <div className='col-md-8'>
          <h3 className='card-lg-title'>{row.desClie}</h3>
        </div>
        <div className='col-md-4'>
          <p className='labelInfo'>Ficha de venta</p>
          <p className='h6 mt-0'>{props.idFichaVenta}</p>
        </div>
      </div>
      <p className='labelInfo'>N° de pedidos</p>
      {row.numPedidoVeh.map((pedido,idPedidos) =>
          <div id={idPedidos} key={idPedidos} >{pedido + ' '}</div>
      )}

      <hr />
      <div className='row'>
        <div className='col-md-3'>
          <p className='labelInfo'>Cliente de facturación</p>
          <p>{row.desClie}</p>
        </div>
        <div className='col-md-3'>
          <p className='labelInfo'>Código de cliente</p>
          <p>{row.codClie}</p>
        </div>
        <div className='col-md-3'>
          <p className='labelInfo'>RUC</p>
          <p>{row.rucClie}</p>
        </div>
        <div className='col-md-3'>
          <p className='labelInfo'>DNI</p>
          <p>{row.dniClie}</p>
        </div>
      </div>
      <hr />

      {props.clientes.filter(entry => entry.codClie===row.codClie && entry.estadoTransitoFact===row.estadoTransitoFact).map((rowClientes,idClientes) =>
          <div id={idClientes} key={idClientes}>
            <div className='row'>
              <div className='col-md-5'>
                <p className='labelInfo'>Dirección</p>
                <p>{rowClientes.direccion}</p>
              </div>
              <div className='col-md-5'>
                <p className='labelInfo'>Contactos adicionales</p>
                  {rowClientes.contactos.map((contato,idContactos)=>
                      contato.nombre!==""?(
                      <div key={idContactos} style={{ float: 'left'}} >{contato.nombre} /  </div>
                    ):null
                  )}
              </div>
            </div>
            {console.log(rowClientes.documento)}
            <hr />
            <div className='row'>
              <div className='col-md-3'>
                <p className='labelInfo'>Documento</p>
                <p>{rowClientes.documento!==null && rowClientes.documento!== undefined ?rowClientes.documento.split('-')[1]:''}</p>
              </div>
              <div className='col-md-3'>
                <p className='labelInfo'>Tipo de pago</p>
                <p>{rowClientes.tipoPago!==null && rowClientes.tipoPago!== undefined ?rowClientes.tipoPago.split('-')[1]:''}</p>
              </div>
              <div className='col-md-3'>
                <p className='labelInfo'>Entidad financiera</p>

                <p>{rowClientes.entidadFinanciera!==null && rowClientes.entidadFinanciera!== undefined ?rowClientes.entidadFinanciera.split('-')[1]:''}</p>
              </div>
            </div>
            <hr />
            <div className='row'>
              <div className='col-xs-12'>
                <p className='labelInfo'>Tipo de Solicitud</p>
                {props.maestroGenericoTipoSolicitud.tablaMaestroLogistica.map((tipo,idTipo)=>
                  <p key={idTipo}>{tipo.codTipo===rowClientes.tipoSolicitud?tipo.descripcion:''}</p>
                )}
              </div>
            </div>
            <hr />
            <div className='row'>
              <div className='col-xs-12'>
                <p className='labelInfo'>Observaciones</p>
                <p>{rowClientes.observaciones}</p>
              </div>
            </div>
          </div>
    )}

    </div>

)}

    <div className='pillSelct'>
        <p className='labelInfo'>Notificar a un colaborador</p>
        <div className='pillSelct-field'>
          <div className='awesomplete'>
            <Autocomplete
              getItemValue={item => item.idUsuario.toString()}
              value={props.colaborador}
              items={props.colaboradores}
              renderItem={(item, isHighlighted) =>
                <div key={item.idUsuario} style={{ background: isHighlighted ? 'lightgray' : 'white', padding: '6px 12px' }}>
                  {`${item.apellidos} ${item.nombre}`}
                </div>
              }
              onChange={props.changeColaborador}
              menuStyle={menuStyle}
              inputProps={inputProps}
              wrapperStyle={{ display: 'block' }}
              onSelect={props.selectColaborador}
            />
          </div>
          <div className='pillSelct-pills'>
            {
              props.colaboradoresSeleccionados.map((colaborador, idColaborador) => (
                <label key={idColaborador} className='pill pill-cyan pillSelct-pills-item' htmlFor='colaborador'>
                  {colaborador.nombres}
                  <button
                    className='pillSelct-delete'
                    onClick={() => props.removeColaborador(colaborador.id)}
                  ><i className='icon ion-close pill-close' />
                  </button>
                </label>
              ))
            }
          </div>

        </div>
      </div>
    <div className='modal-actions'>
      <button className='btn btn-default' onClick={props.previousStep}>Anterior</button>
      <button onClick={()=>props.grabarFacturacion()} className='btn btn-primary pull-right'>Enviar solicitud</button>
    </div>
  </section>
);

export default FourthStep;



// WEBPACK FOOTER //
// ./src/pages/modals/SolicitarFacturacion/FourthStep.js